import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { USER_ROLES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';


@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.scss'],
})
export class UserAccessComponent implements OnInit {
  @Input() userId: any;
  @Input() editUserId: any;
  @Input() storedFormData: any;


  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitUser: EventEmitter<void> = new EventEmitter<void>();


  @Output() showReview: EventEmitter<void> = new EventEmitter<void>();


  accessForm!: FormGroup;

  isAccessEditEnabled: boolean = false;


  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder
  ) { }


  ngOnInit(): void {
    if(localStorage.getItem("Role") === USER_ROLES.CLIENT_ADMIN){
      this.isAccessEditEnabled = true;
    }
    this.accessForm = this._fb.group({
      modules: this._fb.array([]),
      userId: [this.userId],
      organizationId: [],
      id: [],
      createdBy: [],
      createDate: []
    });


    this.accessForm.valueChanges.subscribe(() => {
      this.accessForm.markAsDirty();
      this.accessForm.markAsTouched();
    })


    if(this.storedFormData){
      this.patchFormData(this.storedFormData);
      this.accessForm.markAsPristine();
    }
  }


  ngOnChanges() {
    if (this.storedFormData && this.accessForm) {
      this.patchFormData(this.storedFormData);
      this.accessForm.markAsPristine();
    }
  }


  patchFormData(formData:any){
    this.accessForm.patchValue({
      ...formData
    });


    const modulesArray = this.getModuleArray();
    modulesArray.clear();


    if (formData.modules && formData.modules.length > 0) {
      formData.modules.forEach((module: any) => {
        const moduleGroup = this.createModuleFormGroup(module);
        modulesArray.push(moduleGroup);
      });
    }
  }


  getModuleArray(): FormArray {
    return this.accessForm.get('modules') as FormArray;
  }
  createModuleFormGroup(module: any): FormGroup {
    let group = this._fb.group({
      moduleName: [module?.moduleName],
      create: [module?.create],
      edit: [module?.edit],
      view: [module?.view],
      delete: [module?.delete],
      startDate: [module?.startDate],
      endDate: [module?.endDate],
    })

    if(this.isAccessEditEnabled){
      group.get('create')?.enable();
      group.get('edit')?.enable();
      group.get('view')?.enable();
      group.get('delete')?.enable();
    }else{
      group.get('create')?.disable();
      group.get('edit')?.disable();
      group.get('view')?.disable();
      group.get('delete')?.disable();
    }
    return group;
  }


  async onSubmit(): Promise<boolean> {
    if (this.accessForm.valid) {
      try {
        const formData = this.accessForm.getRawValue();
        this.accessForm.markAsPristine();
        this.storeFormData.emit(formData);
        this.submitUser.emit();
        return true;
      } catch (error) {
        console.error("Error while adding visa info", error);
        return false;
      }
    } else {
      this.accessForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }
  }


  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }
  goPrevious() {
    this.viewChange.emit(true);
  }


  async saveAndNext() {
    try {
      const result = await this.onSubmit();
      if (result) {
        this.goNextTab();
      }
    } catch (error) {
      console.error('Error during save and next:', error);
    }
  }


  // next function
  goNextTab() {
    this.showReview.emit();
  }


  formDataModified(): boolean {
    return (this.accessForm.dirty || this.accessForm.invalid) && this.accessForm.touched;
  }
}



